import { render, staticRenderFns } from "./products-page.vue?vue&type=template&id=98baaa4e&scoped=true"
import script from "./products-page.vue?vue&type=script&lang=js"
export * from "./products-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98baaa4e",
  null
  
)

export default component.exports